var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mirror"},[_c('div',{staticClass:"wrap",style:({
      width: _vm.width ? _vm.width + 'px' : 'auto',
      height: _vm.height ? _vm.height + 'px' : 'auto',
    })},[_c('div',{ref:"truth",staticClass:"mirror__truth",on:{"mousemove":_vm.move,"mouseenter":_vm.showMagnify,"mouseleave":_vm.hideMagnify}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMask),expression:"showMask"}],ref:"mask",staticClass:"mask",style:({
          width: _vm.computedWidth / 2 + 'px',
          height: _vm.computedHeight / 2 + 'px',
          left: _vm.maskPosition.x + 'px',
          top: _vm.maskPosition.y + 'px',
        })}),_vm._v(" "),_c('v-lazy-img',{ref:"img",attrs:{"src":_vm.thumbnail,"data-url":_vm.url},on:{"load":_vm.imgLoad}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowVirtual),expression:"isShowVirtual"}],ref:"virtual",staticClass:"virtual",style:({
        width: _vm.computedWidth + 'px',
        height: _vm.computedHeight + 'px',
        left: _vm.bodyPosition && _vm.bodyPosition.x + 'px',
        top: _vm.bodyPosition && _vm.bodyPosition.y + 'px',
      })},[_c('div',{ref:"bigPic",staticClass:"big",style:({
          position: 'absolute',
          width: 2 * _vm.computedWidth + 'px',
          height: 2 * _vm.computedHeight + 'px',
          backgroundSize: '100% 100%',
          backgroundImage: ("url(" + (_vm.bigUrl || _vm.url) + ")"),
          left: _vm.percent.x,
          top: _vm.percent.y,
        })})])])])}
var staticRenderFns = []

export { render, staticRenderFns }